<template>
  <div :class="[$style.example_content_item]">
    <div :class="[$style.example_content_item_title , $style.first_title]">
      {{ title }}
    </div>

    <div :class="$style.example_content_2_items">
      <div
        :class="$style.example_block"
        @click="()=>onCreateReport('milestone', progressTitleLocales.milestone)"
      >
        <div :class="$style.example_block_title">
          <div :class="$style.text">
            {{ locale(`${progressTitleLocales.milestone}`) }}
          </div>

          <vgp-button
            type="text"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`exmp_chart_milestone_desc`) }}
        </div>
        <div :class="$style.example_block_chart">
          <img
            :class="$style.img"
            :src="'https://cdn.ganttpro.com/app/imgs/reports/reportMilestone.png'"
          >
        </div>
      </div>

      <div
        :class="$style.example_block"
        @click="()=>onCreateReport('statuses', progressTitleLocales.status)"
      >
        <div :class="$style.example_block_title">
          <div :class="$style.text">
            {{ locale(`${progressTitleLocales.status}`) }}
          </div>

          <vgp-button
            type="text"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`exmp_chart_project_by_status_desc`) }}
        </div>
        <div :class="$style.example_block_chart">
          <img
            :class="$style.img"
            :src="'https://cdn.ganttpro.com/app/imgs/reports/reportStatus.png'"
          >
        </div>
      </div>
    </div>

    <div :class="$style.example_content_2_items">
      <div
        :class="[$style.example_block,$style.full_size]"
        @click="()=>onCreateReport('portfolio', progressTitleLocales.projectsList)"
      >
        <div :class="$style.example_block_title">
          <div :class="$style.text">
            {{ locale(`${progressTitleLocales.projectsList}`) }}
          </div>

          <vgp-button
            type="text"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`exmp_chart_project_list_desc`) }}
        </div>
        <div
          :class="$style.example_block_chart"
          :style="{paddingBottom: '38px'}"
        >
          <img
            :class="$style.img"
            :src="'https://cdn.ganttpro.com/app/imgs/reports/reportProjectsList.png'"
          >
        </div>
      </div>
    </div>

    <div :class="$style.example_content_2_items">
      <div
        :class="[$style.example_block]"
        @click="()=>onCreateReport('schedule', progressTitleLocales.schedule)"
      >
        <div :class="$style.example_block_title">
          <div :class="$style.text">
            {{ locale(`${progressTitleLocales.schedule}`) }}
          </div>

          <vgp-button
            type="text"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`exmp_chart_project_schedule_desc`) }}
        </div>
        <div :class="$style.example_block_chart">
          <img
            :class="$style.img"
            :src="'https://cdn.ganttpro.com/app/imgs/reports/reportSchedule.png'"
          >
        </div>
      </div>

      <div
        :class="[$style.example_block]"
        @click="()=>onCreateReport('month', progressTitleLocales.monthProgress)"
      >
        <div :class="$style.example_block_title">
          <div :class="$style.text">
            {{ locale(`${progressTitleLocales.monthProgress}`) }}
          </div>

          <vgp-button
            type="text"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`exmp_chart_progress_by_month_desc`) }}
        </div>
        <div :class="$style.example_block_chart">
          <img
            :class="$style.img"
            :src="'https://cdn.ganttpro.com/app/imgs/reports/reportProgressMonth.png'"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vgpSvgImage from '$$vueCmp/VueIcon/vgpSvgImage.vue';
import reportConstants from '../include/constants';

export default {
  components: {
    vgpSvgImage,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      locale: __,
      progressTitleLocales: reportConstants.TITLE.progress,
    };
  },
  methods: {
    onCreateReport(type, title) {
      this.$emit('onCreateReport', {
        title,
        type,
        routerName: 'progressReports',
      });
    },
  },
};
</script>

<style module src='./../less/reportsMain.less'></style>
